import { RoleType } from '@csp/dmdp-api-common-dto';
import { PermissionType } from '../type/PermissionType';

const permissionsByRole: Map<RoleType, PermissionType[]> = new Map([
  [
    RoleType.CRA,
    [
      PermissionType.MANAGE_SITES,
      PermissionType.SITE_TEAM_ADMIN,
      PermissionType.READ_PATIENT,
      PermissionType.VIEW_PATIENT_ACCOUNT,
      PermissionType.VIEW_QUESTIONNAIRE_RESPONSE,
      PermissionType.CAN_APPROVE_EC_STATUS,
      PermissionType.CAN_EXPORT_CLOSEOUT_DATA,
      PermissionType.VIEW_USER_DETAILS_REPORT,
      PermissionType.CAN_REQUEST_ARCHIVING_EXPORT,
      PermissionType.CAN_EXPORT_MASTER_TEMPLATES,
      PermissionType.CAN_WRITE_TO_STUDY_DOCS_FILE,
      PermissionType.CAN_SET_STUDY_DOCS_FILE_COUNTRY_ACCESS_LEVEL,
      PermissionType.CAN_VIEW_STUDY_DOCS_COUNTRIES_FILTER,
      PermissionType.CAN_VIEW_STUDY_DOCS_ROLES_FILTER,
      PermissionType.CAN_VIEW_STUDY_DOCS_ROLES_DETAILS,
      PermissionType.CAN_EXPORT_USER_REPORT,
      PermissionType.CAN_DOWNLOAD_SITE,
      PermissionType.REQUEST_ATR_ON_DEMAND,
      PermissionType.CAN_LIST_STUDY_ICFS,
      PermissionType.CAN_VIEW_STUDY_ICF,
      PermissionType.CAN_LIST_COUNTRY_ICFS,
      PermissionType.CAN_MANAGE_COUNTRY_ICF,
      PermissionType.CAN_VIEW_COUNTRY_ICF,
      PermissionType.CAN_LIST_PRACTICE_ICFS,
      PermissionType.CAN_MANAGE_PRACTICE_ICFS,
      PermissionType.CAN_VIEW_PRACTICE_ICF,
      PermissionType.CAN_VIEW_STUDY_DOCUMENTS,
      PermissionType.CAN_VIEW_STUDY_ARCHIVING,
      PermissionType.CAN_VIEW_SYSTEM_LINKS,
      PermissionType.CAN_VIEW_REPORTS,
      PermissionType.CAN_VIEW_PATIENTS,
      PermissionType.CAN_VIEW_SUPPORT_SECTION,
      PermissionType.CAN_VIEW_SITES,
      PermissionType.CAN_USE_COMMAND_PALETTE,
      PermissionType.CAN_VIEW_MY_PROFILE,
      PermissionType.VIEW_STUDY_METRICS,
      PermissionType.CAN_APPROVE_CONSENTS,
      PermissionType.CAN_VIEW_REVOKED_POSITIONS,
      PermissionType.CAN_RESEND_TEAM_MEMBER_INVITE,
    ],
  ],
  [
    RoleType.PI,
    [
      PermissionType.MANAGE_VISIT,
      PermissionType.MANAGE_PATIENT,
      PermissionType.SITE_TEAM_ADMIN,
      PermissionType.MANAGE_SITE_LOCATIONS,
      PermissionType.READ_PATIENT,
      PermissionType.VIEW_PATIENT_CONTACT_POINT,
      PermissionType.VIEW_PATIENT_ACCOUNT,
      PermissionType.MANAGE_MEDICATION,
      PermissionType.VIEW_QUESTIONNAIRE_RESPONSE,
      PermissionType.MANAGE_QUESTIONNAIRE_RESPONSE,
      PermissionType.VIEW_HEALTH_EVENT_RESPONSE,
      PermissionType.MANAGE_HEALTH_EVENT,
      PermissionType.VIEW_OTHER_SITES_METRICS,
      PermissionType.CAN_START_SPIROMETRY_SESSION,
      PermissionType.CAN_MANAGE_SPIROMETRY_SESSION,
      PermissionType.CAN_INITIATE_ON_DEMAND_MEASUREMENT_REQUEST,
      PermissionType.CAN_EXPORT_CLOSEOUT_DATA,
      PermissionType.CAN_COMPILE_QUESTIONNAIRE,
      PermissionType.VIEW_DATA_CHANGE_EDIT,
      PermissionType.MANAGE_DATA_CHANGE_EDIT,
      PermissionType.MANAGE_HBS,
      PermissionType.CAN_REVIEW_DATA_CHANGE,
      PermissionType.MANAGE_RPM_EVENT,
      PermissionType.MANAGE_REQUEST_TAGS,
      PermissionType.CAN_EXPORT_MASTER_TEMPLATES,
      PermissionType.CAN_WRITE_TO_STUDY_DOCS_FILE,
      PermissionType.CAN_EXPORT_USER_REPORT,
      PermissionType.CAN_MANAGE_PROVISIONED_DEVICE,
      PermissionType.CAN_DOWNLOAD_SITE,
      PermissionType.REQUEST_ATR_ON_DEMAND,
      PermissionType.VIEW_RTSM_CHIP,
      PermissionType.CAN_VIEW_STUDY_ICF,
      PermissionType.CAN_LIST_COUNTRY_ICFS,
      PermissionType.CAN_VIEW_COUNTRY_ICF,
      PermissionType.CAN_LIST_PRACTICE_ICFS,
      PermissionType.CAN_MANAGE_PRACTICE_ICFS,
      PermissionType.CAN_VIEW_PRACTICE_ICF,
      PermissionType.CAN_VIEW_STUDY_DOCUMENTS,
      PermissionType.CAN_VIEW_STUDY_ARCHIVING,
      PermissionType.CAN_VIEW_SYSTEM_LINKS,
      PermissionType.CAN_VIEW_REPORTS,
      PermissionType.CAN_VIEW_PATIENTS,
      PermissionType.CAN_VIEW_SUPPORT_SECTION,
      PermissionType.CAN_VIEW_SITES,
      PermissionType.CAN_VIEW_MY_PROFILE,
      PermissionType.CAN_BYPASS_DATA_CHANGE_REVIEW,
      PermissionType.CAN_USE_COMMAND_PALETTE,
      PermissionType.VIEW_STUDY_METRICS,
      PermissionType.CAN_APPROVE_CONSENTS,
      PermissionType.CAN_VIEW_REVOKED_POSITIONS,
      PermissionType.CAN_RESEND_TEAM_MEMBER_INVITE,
    ],
  ],
  [
    RoleType.INVESTIGATOR,
    [
      PermissionType.MANAGE_VISIT,
      PermissionType.MANAGE_PATIENT,
      PermissionType.MANAGE_SITE_LOCATIONS,
      PermissionType.READ_PATIENT,
      PermissionType.VIEW_PATIENT_CONTACT_POINT,
      PermissionType.VIEW_PATIENT_ACCOUNT,
      PermissionType.MANAGE_MEDICATION,
      PermissionType.VIEW_QUESTIONNAIRE_RESPONSE,
      PermissionType.MANAGE_QUESTIONNAIRE_RESPONSE,
      PermissionType.VIEW_HEALTH_EVENT_RESPONSE,
      PermissionType.MANAGE_HEALTH_EVENT,
      PermissionType.VIEW_OTHER_SITES_METRICS,
      PermissionType.CAN_MANAGE_SPIROMETRY_SESSION,
      PermissionType.CAN_START_SPIROMETRY_SESSION,
      PermissionType.CAN_INITIATE_ON_DEMAND_MEASUREMENT_REQUEST,
      PermissionType.CAN_EXPORT_CLOSEOUT_DATA,
      PermissionType.CAN_COMPILE_QUESTIONNAIRE,
      PermissionType.VIEW_DATA_CHANGE_EDIT,
      PermissionType.MANAGE_DATA_CHANGE_EDIT,
      PermissionType.MANAGE_HBS,
      PermissionType.MANAGE_RPM_EVENT,
      PermissionType.MANAGE_REQUEST_TAGS,
      PermissionType.CAN_REVIEW_DATA_CHANGE,
      PermissionType.CAN_EXPORT_MASTER_TEMPLATES,
      PermissionType.CAN_WRITE_TO_STUDY_DOCS_FILE,
      PermissionType.CAN_EXPORT_USER_REPORT,
      PermissionType.CAN_MANAGE_PROVISIONED_DEVICE,
      PermissionType.CAN_DOWNLOAD_SITE,
      PermissionType.REQUEST_ATR_ON_DEMAND,
      PermissionType.VIEW_RTSM_CHIP,
      PermissionType.CAN_VIEW_STUDY_DOCUMENTS,
      PermissionType.CAN_VIEW_STUDY_ARCHIVING,
      PermissionType.CAN_VIEW_SYSTEM_LINKS,
      PermissionType.CAN_VIEW_REPORTS,
      PermissionType.CAN_VIEW_PATIENTS,
      PermissionType.CAN_VIEW_SUPPORT_SECTION,
      PermissionType.CAN_VIEW_SITES,
      PermissionType.CAN_VIEW_MY_PROFILE,
      PermissionType.CAN_BYPASS_DATA_CHANGE_REVIEW,
      PermissionType.CAN_USE_COMMAND_PALETTE,
      PermissionType.VIEW_STUDY_METRICS,
      PermissionType.CAN_APPROVE_CONSENTS,
      PermissionType.CAN_VIEW_REVOKED_POSITIONS,
    ],
  ],
  [
    RoleType.STUDY_ASST,
    [
      PermissionType.MANAGE_PATIENT,
      PermissionType.MANAGE_VISIT,
      PermissionType.MANAGE_SITE_LOCATIONS,
      PermissionType.READ_PATIENT,
      PermissionType.VIEW_PATIENT_CONTACT_POINT,
      PermissionType.VIEW_PATIENT_ACCOUNT,
      PermissionType.VIEW_QUESTIONNAIRE_RESPONSE,
      PermissionType.MANAGE_QUESTIONNAIRE_RESPONSE,
      PermissionType.VIEW_HEALTH_EVENT_RESPONSE,
      PermissionType.MANAGE_HEALTH_EVENT,
      PermissionType.VIEW_OTHER_SITES_METRICS,
      PermissionType.CAN_MANAGE_SPIROMETRY_SESSION,
      PermissionType.CAN_START_SPIROMETRY_SESSION,
      PermissionType.CAN_INITIATE_ON_DEMAND_MEASUREMENT_REQUEST,
      PermissionType.CAN_EXPORT_CLOSEOUT_DATA,
      PermissionType.CAN_COMPILE_QUESTIONNAIRE,
      PermissionType.VIEW_DATA_CHANGE_EDIT,
      PermissionType.MANAGE_DATA_CHANGE_EDIT,
      PermissionType.MANAGE_HBS,
      PermissionType.MANAGE_MEDICATION,
      PermissionType.MANAGE_RPM_EVENT,
      PermissionType.MANAGE_REQUEST_TAGS,
      PermissionType.CAN_EXPORT_MASTER_TEMPLATES,
      PermissionType.CAN_WRITE_TO_STUDY_DOCS_FILE,
      PermissionType.CAN_EXPORT_USER_REPORT,
      PermissionType.CAN_MANAGE_PROVISIONED_DEVICE,
      PermissionType.CAN_DOWNLOAD_SITE,
      PermissionType.REQUEST_ATR_ON_DEMAND,
      PermissionType.VIEW_RTSM_CHIP,
      PermissionType.CAN_VIEW_STUDY_DOCUMENTS,
      PermissionType.CAN_VIEW_STUDY_ARCHIVING,
      PermissionType.CAN_VIEW_SYSTEM_LINKS,
      PermissionType.CAN_VIEW_REPORTS,
      PermissionType.CAN_VIEW_PATIENTS,
      PermissionType.CAN_VIEW_SUPPORT_SECTION,
      PermissionType.CAN_VIEW_SITES,
      PermissionType.CAN_VIEW_MY_PROFILE,
      PermissionType.CAN_BYPASS_DATA_CHANGE_REVIEW,
      PermissionType.CAN_USE_COMMAND_PALETTE,
      PermissionType.VIEW_STUDY_METRICS,
      PermissionType.CAN_APPROVE_CONSENTS,
      PermissionType.CAN_VIEW_REVOKED_POSITIONS,
    ],
  ],
  [
    RoleType.READ_ALL,
    [
      PermissionType.READ_PATIENT,
      PermissionType.VIEW_OTHER_SITES_METRICS,
      PermissionType.VIEW_PATIENT_CONTACT_POINT,
      PermissionType.VIEW_PATIENT_ACCOUNT,
      PermissionType.CAN_EXPORT_CLOSEOUT_DATA,
      PermissionType.VIEW_HEALTH_EVENT_RESPONSE,
      PermissionType.VIEW_QUESTIONNAIRE_RESPONSE,
      PermissionType.VIEW_RTSM_CHIP,
      PermissionType.CAN_VIEW_STUDY_DOCUMENTS,
      PermissionType.CAN_VIEW_STUDY_ARCHIVING,
      PermissionType.CAN_VIEW_SYSTEM_LINKS,
      PermissionType.CAN_VIEW_REPORTS,
      PermissionType.CAN_VIEW_PATIENTS,
      PermissionType.CAN_VIEW_SUPPORT_SECTION,
      PermissionType.CAN_VIEW_SITES,
      PermissionType.CAN_USE_COMMAND_PALETTE,
      PermissionType.CAN_VIEW_MY_PROFILE,
      PermissionType.VIEW_STUDY_METRICS,
      PermissionType.CAN_APPROVE_CONSENTS,
      PermissionType.CAN_VIEW_REVOKED_POSITIONS,
    ],
  ],
  [
    RoleType.SSTM,
    [
      PermissionType.READ_PATIENT,
      PermissionType.VIEW_PATIENT_CONTACT_POINT,
      PermissionType.VIEW_PATIENT_ACCOUNT,
      PermissionType.VIEW_QUESTIONNAIRE_RESPONSE,
      PermissionType.VIEW_HEALTH_EVENT_RESPONSE,
      PermissionType.CAN_DEBUG_CMS,
      PermissionType.VIEW_DATA_CHANGE_EDIT,
      PermissionType.VIEW_USER_DETAILS_REPORT,
      PermissionType.CAN_VIEW_STUDY_DOCS_COUNTRIES_FILTER,
      PermissionType.CAN_VIEW_STUDY_DOCS_ROLES_FILTER,
      PermissionType.CAN_EXPORT_USER_REPORT,
      PermissionType.CAN_VIEW_STUDY_DOCUMENTS,
      PermissionType.CAN_VIEW_STUDY_ARCHIVING,
      PermissionType.CAN_VIEW_SYSTEM_LINKS,
      PermissionType.CAN_VIEW_REPORTS,
      PermissionType.CAN_VIEW_PATIENTS,
      PermissionType.CAN_VIEW_SUPPORT_SECTION,
      PermissionType.CAN_VIEW_SITES,
      PermissionType.CAN_USE_COMMAND_PALETTE,
      PermissionType.CAN_VIEW_MY_PROFILE,
      PermissionType.VIEW_STUDY_METRICS,
      PermissionType.CAN_APPROVE_CONSENTS,
      PermissionType.CAN_VIEW_REVOKED_POSITIONS,
    ],
  ],
  [
    RoleType.GSTM,
    [
      PermissionType.VIEW_PATIENT_ACCOUNT,
      PermissionType.VIEW_PATIENT_CONTACT_POINT,
      PermissionType.VIEW_QUESTIONNAIRE_RESPONSE,
      PermissionType.MANAGE_STUDY_CLOSE_OUT_TRACKER,
      PermissionType.CAN_EXPORT_CLOSEOUT_DATA,
      PermissionType.VIEW_USER_DETAILS_REPORT,
      PermissionType.CAN_EMPTY_STUDY_DOCS_TRASH,
      PermissionType.CAN_EXPORT_MASTER_TEMPLATES,
      PermissionType.CAN_MANAGE_STUDY_DOCS_FOLDERS,
      PermissionType.CAN_WRITE_TO_STUDY_DOCS_FILE,
      PermissionType.CAN_SET_STUDY_DOCS_FILE_LOCATION,
      PermissionType.CAN_SET_STUDY_DOCS_FILE_ACCESS_LEVEL_ROLES,
      PermissionType.CAN_SET_STUDY_DOCS_FILE_STUDY_ACCESS_LEVEL,
      PermissionType.CAN_SET_STUDY_DOCS_FILE_COUNTRY_ACCESS_LEVEL,
      PermissionType.CAN_VIEW_STUDY_DOCS_COUNTRIES_FILTER,
      PermissionType.CAN_VIEW_STUDY_DOCS_ROLES_FILTER,
      PermissionType.CAN_VIEW_STUDY_DOCS_ROLES_DETAILS,
      PermissionType.CAN_EDIT_STUDY_DOCS_FILE_ACCESS_LEVEL_ROLES,
      PermissionType.CAN_EXPORT_USER_REPORT,
      PermissionType.CAN_DOWNLOAD_SITE,
      PermissionType.REQUEST_ATR_ON_DEMAND,
      PermissionType.CAN_LIST_STUDY_ICFS,
      PermissionType.CAN_VIEW_STUDY_ICF,
      PermissionType.CAN_MANAGE_STUDY_ICFS,
      PermissionType.CAN_LIST_COUNTRY_ICFS,
      PermissionType.CAN_VIEW_COUNTRY_ICF,
      PermissionType.CAN_MANAGE_COUNTRY_ICF,
      PermissionType.CAN_LIST_PRACTICE_ICFS,
      PermissionType.CAN_VIEW_PRACTICE_ICF,
      PermissionType.CAN_VIEW_STUDY_DOCUMENTS,
      PermissionType.CAN_VIEW_STUDY_ARCHIVING,
      PermissionType.CAN_VIEW_SYSTEM_LINKS,
      PermissionType.CAN_VIEW_REPORTS,
      PermissionType.CAN_VIEW_PATIENTS,
      PermissionType.CAN_VIEW_SUPPORT_SECTION,
      PermissionType.CAN_VIEW_SITES,
      PermissionType.CAN_USE_COMMAND_PALETTE,
      PermissionType.CAN_VIEW_MY_PROFILE,
      PermissionType.VIEW_STUDY_METRICS,
      PermissionType.CAN_APPROVE_CONSENTS,
      PermissionType.CAN_VIEW_REVOKED_POSITIONS,
    ],
  ],
  [RoleType.SUPPORT_MANAGE, [PermissionType.CAN_INVITE_TEAM_MEMBER, PermissionType.CAN_RESEND_TEAM_MEMBER_INVITE]],
]);

const getPermissionsByRole = (role: RoleType): PermissionType[] => {
  const permissions = permissionsByRole.get(role);
  return permissions ?? [];
};

export const PermissionConfigService = {
  getPermissionsByRole,
};
